<template>
  <div>
    <form id="formResetPassword" class="forget-form" style="display:block;">
        <h3 class="font-green">Réinitialisation de votre mot de passe</h3>
        <p> Entrer votre nouveau mot de passe. </p>
        <div class="form-group">
            <input type="password" class="form-control mt-10" placeholder="Nouveau mot de passe" autocomplete="off" required id="newPassword2" v-on:change="reValidateInput('confirmNewPassword2')" data-parsley-equalto="#confirmNewPassword2" data-parsley-error-message="Les mots de passe ne correspondent pas."	 v-model="newPassword">
            <input type="password" class="form-control mt-10" placeholder="Confirmation du nouveau mot de passe" id="confirmNewPassword2" v-on:change="reValidateInput('newPassword2')" data-parsley-equalto="#newPassword2" data-parsley-error-message="Les mots de passe ne correspondent pas."	 autocomplete="off" required>
        </div>
        <div class="form-actions">
            <!-- <a type="button" id="back-btn" class="btn yellow btn-outline" v-on:click="show.login = true">Retour</a> -->
            <a class="btn btn-success uppercase pull-right" v-on:click="resetPassword()">Réinitialiser</a>
        </div>
    </form>
  </div>
</template>

<script>

  import users from '../../requests/users.js'

  export default {
    created () {
    },
    props: ["show"],
    data(){
      return{
        newPassword:""
      }
    },
    mounted:function(){
    },
    methods:{
      reValidateInput(id){
        setTimeout(function(){
          $("#"+id).parsley().validate();
        },50)
      },
      resetPassword(){
        $('#formResetPassword').parsley().validate()
        if($("#formResetPassword").parsley().isValid()){
          var parent = this;
          users.resetPassword(this,this.newPassword,this.$route.query.Authorization,function(err){
            if(err){
              toastr.error(err,"ERREUR");
            }
            else{
              toastr.success("Votre mot de passe a été modifié. Vous pouvez maintenant essayer de vous connecter.");
              parent.show.login = true;
            }
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resetPassword.vue?ceea50ba